import React from 'react'
import theme from '../../config/theme'

interface RichMenuTabsProps {
  activeTab: 'all' | 'active' | 'schedule' | 'archive'
  onTabChange: (tab: 'all' | 'active' | 'schedule' | 'archive') => void
  counts: {
    total: number
    totalActive: number
    totalSchedule: number
    totalArchived: number
  }
}

const RichMenuTabs: React.FC<RichMenuTabsProps> = ({
  activeTab,
  onTabChange,
  counts
}) => {
  const tabs = [
    { key: 'all' as const, label: 'All', count: counts.total },
    {
      key: 'active' as const,
      label: 'Active',
      count: counts.totalActive
    },
    {
      key: 'schedule' as const,
      label: 'Schedule',
      count: counts.totalSchedule
    },
    {
      key: 'archive' as const,
      label: 'Expired / Inactive',
      count: counts.totalArchived
    },
  ]

  return (
    <div className="flex space-x-8 mb-6">
      {tabs.map(tab => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className="pb-2 border-b-2 font-medium transition-colors"
          style={{
            borderColor: activeTab === tab.key ? theme.brandColor.red : 'transparent',
            color: activeTab === tab.key ? theme.brandColor.red : theme.color.gray200
          }}
          onMouseEnter={(e) => {
            if (activeTab !== tab.key) {
              e.currentTarget.style.color = theme.color.gray500
            }
          }}
          onMouseLeave={(e) => {
            if (activeTab !== tab.key) {
              e.currentTarget.style.color = theme.color.gray200
            }
          }}
        >
          {tab.label}
          <div className="inline-block px-2 py-1 rounded-full text-xs font-medium ml-2"
            style={{ backgroundColor: activeTab === tab.key ? theme.brandColor.red +20 : theme.color.light300, color: activeTab === tab.key ? theme.brandColor.red : theme.color.gray500 }}>
            {tab.count}
          </div>
        </button>
      ))}
    </div >
  )
};

export default RichMenuTabs;
